import { objSort, removeFalsy } from "@/utils/help";
import { getToken } from "@/utils/storage";
import Md5 from "crypto-js/md5";
import { pickBy } from "lodash-es";

/**
 * 移除对象中的File值
 * @param obj
 */
export const removeFileData = (
  obj: Record<string, unknown>,
): Record<string, unknown> => {
  if (Object.prototype.toString.call(obj) !== "[object Object]") {
    return obj;
  }
  return pickBy(
    obj,
    (value) => Object.prototype.toString.call(value) !== "[object File]",
  );
};

/**
 * 拼接对象
 * @param data
 */
export const splicingObject = (data: Record<string, unknown>): string => {
  const entries = Object.entries(data).map(([key, value]) => {
    let formattedValue = value;
    if (
      ["Array", "Object"].includes(
        Object.prototype.toString.call(value).slice(8, -1),
      )
    ) {
      formattedValue = JSON.stringify(value);
    } else if (typeof value === "string") {
      formattedValue = value.trim();
    }
    return `${key}=${formattedValue as keyof typeof value}`;
  });
  return entries.join("&");
};

/**
 * 接口签名
 */
export const generateSign = (data: Record<string, unknown>): string => {
  const token = getToken();
  const entityData = removeFalsy(data, "");
  const noFileEntityData = removeFileData(entityData);
  const sortData = objSort(noFileEntityData);
  const strData = splicingObject(sortData);
  // Java中读取换行符是\r\n，js中是\n，所以需要替换一下
  const formatStrData = strData.replace(/\r?\n/g, "\r\n");
  const signStr = `${formatStrData}&key=${token}`;
  return Md5(signStr).toString().toUpperCase();
};
